import { createContext, useContext } from "react";

import type { SplitButtonVariant } from "./types";

type SplitButtonContextValue = {
  variant: SplitButtonVariant;
};

export const SplitButtonContext = createContext<SplitButtonContextValue>({
  variant: "primary",
});

export const useSplitButtonContext = () => {
  const context = useContext(SplitButtonContext);

  return context;
};
